<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style5', { sticky: isSticky }]">
      <MainNavbar />
    </div>
    <MainBanner />
    <GetToKnowUs />
    <BestServices />
    <HowWeWork />
    <BookAppointment />
    <GalleryExhibition />
    <OurTestimonials />
    <OurDoctors />
    <OurPricing />
    <TouchWithUs />
    <OurPartner />
    <LatestNews />
    <MainFooter />
  </div>
</template>

<script lang="ts">
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeFive/MainBanner.vue";
import GetToKnowUs from "../HomeFive/GetToKnowUs.vue";
import BestServices from "../HomeFive/BestServices.vue";
import HowWeWork from "../HomeFive/HowWeWork.vue";
import BookAppointment from "../HomeFive/BookAppointment.vue";
import GalleryExhibition from "../HomeFive/GalleryExhibition.vue";
import OurTestimonials from "../HomeFive/OurTestimonials.vue";
import OurDoctors from "../HomeFive/OurDoctors.vue";
import OurPricing from "../HomeFive/OurPricing.vue";
import TouchWithUs from "../HomeFive/TouchWithUs.vue";
import OurPartner from "../HomeFive/OurPartner.vue";
import LatestNews from "../HomeFive/LatestNews.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeFivePage",
  components: {
    MainNavbar,
    MainBanner,
    GetToKnowUs,
    BestServices,
    HowWeWork,
    BookAppointment,
    GalleryExhibition,
    OurTestimonials,
    OurDoctors,
    OurPricing,
    TouchWithUs,
    OurPartner,
    LatestNews,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>